<template>
  <component :is="tag" :class="classes" :role="role">
    <template v-if="isHeading">
      <h6><slot></slot></h6>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </component>
</template>

<script lang="ts">
  import Vue from "vue";

  /*
    type: Bootstrap / *Custom,
    size:
    - fix size: 45                    ->  30 .. 400, 600
    - percent: 25%                    ->  5% .. 100%
    - base 100 grid: 25/100           ->  5/100 .. 100/100
    - base 12 grid: 6/12 (boostrap)   ->  1/12 .. 12/12
    - colum as base: 1/7              ->  1/1 .. 1/16
    - column 45% minus 20px: 45%-20
    - column 4/12 minus 20px: 4/12-20
  */

  export default Vue.extend({
    props: {
      tag: {
        type: String,
        default: 'div'
      },
      type: {
        type: String,
        default: 'column'
      },
      size: {
        default: ''
      },
      isHeading: {
        type: Boolean,
        default: false
      },
      allowGrowing: {
        type: Boolean,
        default: false
      },
      allowShrink: {
        type: Boolean,
        default: false
      },
      tableElement: {
        type: Boolean,
        default: false,
      },
    },
    data: function(){
      return {
        grid: {
          'bootstrap': 'col',
          'prefix': 'prefix',
          'column': 'column',
          'suffix': 'suffix',
        },
      }
    },
    computed: {
      classes(): object {
        return [
          this.grid[this.type],
          this.computedSize,
          {
            'allow-growing': this.allowGrowing,
            'allow-shrink': this.allowShrink,
          }
        ]
      },
      computedSize() {
        let result = this.size;
        let isInteger = /^\d+$/.test(this.size);
        let isBinomial = /[-]/.test(this.size);
        let isPercent = /[%]/.test(this.size);
        let isFraction = /[/]/.test(this.size);
        let isBootstrap = this.type === 'bootstrap';
        let subtraction;

        if (isBinomial) {
          subtraction = this.size.split('-')[1];
          result = this.size.split('-')[0];
        }

        if (isPercent) {
          result = 'sz' + this.roundUpNumber(Math.min(Math.max(parseInt(result, 10), 5), 100)) + 'b100';
        } else if(isFraction) {
          let fraction = result.split('/');
          let column = fraction[0];
          let grid = fraction[1];

          if (isBootstrap) {
            result = `col-md-${column}`;
          } else {
            result = `sz${column}b${grid}`;
          }
        } else if(isInteger) {
          let isBigColumn = parseInt(result, 10) === 600;
          if(isBigColumn) {
            result = 'sz600';
          } else {
            result = 'sz' + this.roundUpNumber(Math.min(Math.max(parseInt(result, 10), 30), 400));
          }
        }

        if(subtraction){
          result = `${result}m${subtraction}`;
        }

        return result;
      },
      role() {
        if(this.tableElement){
          return this.isHeading ? 'columnheader' : 'cell';
        }
      },
    },
    methods: {
      roundUpNumber(value){
        let rest = value % 5;
        let hasNoClassEquivalent = rest > 0;
        if(hasNoClassEquivalent){
          value = value - rest + 5;
        }
        return value.toString();
      }
    }
  });
</script>
